import React from "react";
import PropTypes from "prop-types";
import { Card, CardContainer } from "../../../../components/Card";

import { Typography, useTheme } from "@mui/material";
import { LineChart, PieChart } from "../../../../components/Charts";

const formatRevenue = (revenue) => {
    if (revenue >= 10000000) {
        return `${(revenue / 10000000).toFixed(1)}cr`;
    } else if (revenue >= 100000) {
        return `${(revenue / 100000).toFixed(1)}L`;
    } else if (revenue >= 1000) {
        return `${(revenue / 1000).toFixed(1)}k`;
    } else {
        return `${revenue.toLocaleString()}`;
    }
};

const OverallGalleri5 = ({ data, type }) => {
    const theme = useTheme();
    const calculateTotal = (key) => {
        return data?.reduce((sum, item) => sum + (item[key] || 0), 0);
    };

    const findLastWeek = (key) => {
        const lw = data?.reduce(
            (acc, item) => {
                if (new Date(acc.week) < new Date(item.week)) {
                    acc = item;
                }
                return acc;
            },
            { week: 0 }
        );
        return lw ? lw[key] || 0 : 0;
    };

    const calculateTotalForLastWeekOfEachMonth = (key) => {
        const weeks = getLastWeekOfEachMonth(data);
        return weeks.reduce((sum, item) => sum + (item[key] || 0), 0);
    };

    function getLastWeekArray(data) {
        // Convert date strings to Date objects for easier manipulation
        let parsedData = data?.map((item) => ({
            ...item,
            __week_date: new Date(item.week), // Convert `week` string to Date object
        }));

        // Get last week of data
        let lastWeek = parsedData?.reduce(
            (latest, current) =>
                latest.__week_date > current.__week_date ? latest : current,
            { __week_date: new Date(0) }
        );

        // Get the last week in an array
        return [lastWeek];
    }

    function typeBasedData(data) {
        const dataset = data?.map((item) => ({
            ...item,
            __week_date: new Date(item.week),
        }));

        // if type is weeks, return all data
        if (type === "weeks") {
            return dataset;
        }

        // if type is months, group by month and sum all the numbers || nulls
        const groupedByMonth = dataset?.reduce((acc, item) => {
            let yearMonth =
                item.__week_date.getFullYear() +
                "-" +
                (item.__week_date.getMonth() + 1);
            if (!acc[yearMonth]) {
                acc[yearMonth] = [];
            }
            acc[yearMonth].push(item);
            return acc;
        }, {});

        const excludeKeys = ["week", "__week_date", "pk", "id", "updated_at"];

        return Object.values(groupedByMonth).map((weeks) => {
            return weeks?.reduce((acc, item) => {
                Object.keys(item).forEach((key) => {
                    if (!excludeKeys.includes(key)) {
                        acc[key] = (acc[key] || 0) + (item[key] || 0);
                    } else {
                        acc[key] = item[key];
                    }
                });
                return acc;
            }, {});
        });
    }

    function typeBasedFormatter(val) {
        if (type === "weeks") {
            return undefined;
        }

        console.log("------->", typeBasedData(data));

        return new Date(val).toLocaleDateString("en-US", {
            month: "short",
            year: "2-digit",
        });
    }

    function getLastWeekOfEachMonth(data) {
        // Convert date strings to Date objects for easier manipulation
        let parsedData = data?.map((item) => ({
            ...item,
            __week_date: new Date(item.week), // Convert `week` string to Date object
        }));

        // Group by year and month
        let groupedByMonth = parsedData?.reduce((acc, item) => {
            let yearMonth =
                item.__week_date.getFullYear() +
                "-" +
                (item.__week_date.getMonth() + 1);
            if (!acc[yearMonth]) {
                acc[yearMonth] = [];
            }
            acc[yearMonth].push(item);
            return acc;
        }, {});

        // Get last week of each month
        let lastWeeks = Object.values(groupedByMonth).map((weeks) => {
            return weeks?.reduce(
                (latest, current) =>
                    latest.__week_date > current.__week_date ? latest : current,
                { __week_date: new Date(0) }
            );
        });

        // Remove the extra `__week_date` key before returning
        // eslint-disable-next-line no-unused-vars
        return lastWeeks.map(({ __week_date, ...rest }) => rest);
    }
    return (
        <>
            <CardContainer>
                <Card>
                    <Typography
                        variant="h5"
                        sx={{
                            color: theme.palette.graph.cyan,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                        mb={2}
                    >
                        {formatRevenue(calculateTotal("total_billing"))}
                    </Typography>
                    <Typography
                        variant="captionRegular"
                        sx={{
                            color: theme.palette.neutral[500],
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        Total Overall Revenue
                    </Typography>
                </Card>
                <Card>
                    <Typography
                        variant="h5"
                        sx={{
                            color: theme.palette.graph.yellow,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                        mb={2}
                    >
                        {formatRevenue(findLastWeek("overall_customers"))}
                    </Typography>
                    <Typography
                        variant="captionRegular"
                        sx={{
                            color: theme.palette.neutral[500],
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        Overall Cumulative Customers
                    </Typography>
                </Card>
                <Card>
                    <Typography
                        variant="h5"
                        sx={{
                            color: theme.palette.graph.magenta,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                        mb={2}
                    >
                        {formatRevenue(
                            calculateTotalForLastWeekOfEachMonth(
                                "new_customers"
                            )
                        )}
                    </Typography>
                    <Typography
                        variant="captionRegular"
                        sx={{
                            color: theme.palette.neutral[500],
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        Monthly Billing
                    </Typography>
                </Card>
            </CardContainer>
            <CardContainer>
                <PieChart
                    data={data}
                    series={[
                        {
                            key: "social_intelligence_billing",
                            name: "Social Intelligence",
                        },
                        {
                            key: "trends_billing",
                            name: "Trends ",
                        },
                        {
                            key: "ai_billing",
                            name: "AI ",
                        },
                    ]}
                    title="Overview of Revenue"
                />
                <PieChart
                    data={getLastWeekArray(data)}
                    series={[
                        {
                            key: "customer_social_intelligence",
                            name: "Social Intelligence",
                        },
                        {
                            key: "customer_trends",
                            name: "Trends ",
                        },
                        {
                            key: "customer_ai",
                            name: "AI ",
                        },
                    ]}
                    title="Overview of Overall Cumulative Customers"
                />
            </CardContainer>
            <CardContainer>
                <LineChart
                    data={typeBasedData(data)}
                    series={[
                        {
                            name: "Total Billing",
                            key: "total_billing",
                        },
                    ]}
                    xKey="week"
                    // yLabel="Seats Sold"
                    xFormatter={typeBasedFormatter}
                    title="Revenue Growth"
                />
                <LineChart
                    data={getLastWeekOfEachMonth(data)}
                    series={[
                        {
                            name: "Overall Customers",
                            key: "overall_customers",
                        },
                    ]}
                    xKey="week"
                    // yLabel="Seats Sold"
                    xFormatter={(val) =>
                        new Date(val).toLocaleDateString("en-US", {
                            month: "short",
                            year: "2-digit",
                        })
                    }
                    title="Customer Growth"
                />
            </CardContainer>
        </>
    );
};

OverallGalleri5.propTypes = {
    data: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
};

export default OverallGalleri5;
